// extracted by mini-css-extract-plugin
module.exports = {"bodyMinHeight":"_44e3b5d9"};